import { hrAPI } from '@/lib/api';
import { toast } from 'sonner';

export const DOC_CATEGORY_LABELS = {
  paystub: 'Pay Stub',
  tax: 'Tax Document',
  policy: 'Company Policy',
  hr_doc: 'HR Document',
  benefits_doc: 'Benefits Document',
};

export const PTO_TYPE_LABELS = {
  vacation: 'Vacation',
  sick: 'Sick Leave',
  personal: 'Personal Day',
  unpaid: 'Unpaid Leave',
};

export const STATUS_STYLES = {
  pending: 'bg-amber-100 text-amber-700',
  approved: 'bg-emerald-100 text-emerald-700',
  denied: 'bg-red-100 text-red-700',
  open: 'bg-blue-100 text-blue-700',
  answered: 'bg-emerald-100 text-emerald-700',
  closed: 'bg-slate-100 text-slate-600',
  completed: 'bg-emerald-100 text-emerald-700',
};

export const formatDateShort = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getFullYear()).slice(-2)}`;
};

export const formatMinutes = (minutes) => {
  if (minutes == null) return '—';
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  return `${h}h ${m}m`;
};

export const downloadHRDocument = async (doc) => {
  try {
    const res = await hrAPI.downloadDocument(doc.id);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = doc.file_name || 'document';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    toast.error('Failed to download document');
  }
};
